import checkRoles from '~/utils/check-roles';
import { Roles } from '~/stores/usersStore';

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) {
    return;
  }

  // Get required roles for navigation target
  let requiredRoles = to.meta.requiredRoles as Roles | Roles[];
  if (!requiredRoles) {
    console.log(to.fullPath + ': NO ROLES REQUIRED');

    return;
  }
  if (!Array.isArray(requiredRoles)) {
    requiredRoles = [requiredRoles];
  }

  const pb = usePocketBase();
  // Logged-out users should be prompted to log in, not shown "Access Denied".
  // Preserve the intended destination so login can redirect back.
  if (!pb.authStore.isValid) {
    return navigateTo({
      path: '/user/login',
      query: { redirect: to.fullPath },
    });
  }

  // Check if all roles are assigned to user
  if (!(await checkRoles(requiredRoles))) {
    return navigateTo('/user/no-access');
  }
});
